import { useEffect, useState } from 'preact/hooks';
import { getMyInviteLinks } from '../../data/membership';

export function ShareRow(props: { title: string; url: string; text?: string }) {
  const [copied, setCopied] = useState(false);
  async function doShare() {
    try {
      if (navigator.share) {
        await navigator.share({ title: props.title, text: props.text, url: props.url });
        return;
      }
    } catch {
      // fall through to copy
    }
    try {
      await navigator.clipboard.writeText(props.url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // ignored
    }
  }
  return (
    <div class="install-row" style="display:flex;align-items:center;gap:8px;">
      <code style="flex:1;word-break:break-all;">{props.url}</code>
      <button class="secondary-btn" type="button" onClick={() => void doShare()}>
        Share
      </button>
      <button
        class="secondary-btn"
        type="button"
        onClick={async () => {
          try {
            await navigator.clipboard.writeText(props.url);
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
          } catch {}
        }}
      >
        Copy
      </button>
      {copied && <span class="muted">Copied</span>}
    </div>
  );
}

export function PartnerInvite(props: { onDone?: () => void }) {
  const [state, setState] = useState<
    | { kind: 'loading' }
    | { kind: 'ready'; partnerUrl: string; neighborhoodUrl?: string }
    | { kind: 'unavailable' }
  >({ kind: 'loading' });

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const links = await getMyInviteLinks();
        if (!mounted) return;
        if (!links) {
          setState({ kind: 'unavailable' });
          return;
        }
        const origin = window.location.origin.replace(/\/+$/, '');
        const partnerUrl = `${origin}/family/${links.partner_invite_token}`;
        const neighborhoodUrl = links.is_owner
          ? `${origin}/join/${links.neighborhood_invite_token}`
          : undefined;
        setState({ kind: 'ready', partnerUrl, neighborhoodUrl });
      } catch {
        if (!mounted) return;
        setState({ kind: 'unavailable' });
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  if (state.kind === 'loading') {
    return (
      <section class="install-safe">
        <div class="install-card">
          <h2 class="install-title">Add your partner</h2>
          <div class="install-body">
            <p class="muted">Loading…</p>
          </div>
        </div>
      </section>
    );
  }

  if (state.kind === 'unavailable') {
    return (
      <section class="install-safe">
        <div class="install-card">
          <h2 class="install-title">Add your partner</h2>
          <div class="install-body">
            <p class="muted">Partner invites aren’t available yet.</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section class="install-safe">
      <div class="install-card">
        <h2 class="install-title">Add your partner</h2>
        <div class="install-body">
          <p class="muted">Share this link with your partner:</p>
          <ShareRow title="Shores Park Club" text="Join our family on Shores Park Club" url={state.partnerUrl} />
          <div style="margin-top:12px;">
            <button
              class="btn-secondary"
              type="button"
              style="width:100%;"
              onClick={() => (props.onDone ? props.onDone() : (window.location.href = '/'))}
            >
              Done, go to Home
            </button>
          </div>
          {state.neighborhoodUrl && (
            <>
              <hr />
              <p class="muted">Invite more neighbors:</p>
              <ShareRow title="Shores Park Club" text="Join our neighborhood on Shores Park Club" url={state.neighborhoodUrl} />
            </>
          )}
        </div>
      </div>
    </section>
  );
}

